import { CopyrightOutlined } from "@ant-design/icons";
import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Row, Typography } from "antd";
import colors from "constants/colors";
import { NAVMENU_WIDTH } from "components/NavAdmin/NavMenu";
import { useSetTheme } from "contexts/theme-context";
import HallOfFame from "../../containers/Footer/HallOfFame/HallOfFame";
import useViewport from "../UseViewport/UseViewport";

const { Paragraph } = Typography;

const AdminFooter = () => {
  const setTheme = useSetTheme();
  const { width } = useViewport();
  const breakpoint = 700;

  return (
    <>
      <Row
        style={{
          backgroundColor: colors.darkGray,
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-end",
          marginLeft: `${width >= 768 ? NAVMENU_WIDTH : 0}px`,
        }}
        className="AdminFooter"
      >
        <Row style={{ width: "100%", padding: "0.7em 5% 0.7em 5%" }}>
          <Col span={width < breakpoint ? 24 : 8}>
            <HallOfFame />
          </Col>
          <Col span={width < breakpoint ? 24 : 8} style={width < breakpoint ? {} : { textAlign: "center" }}>
            <Button type="link" style={{ color: "grey", padding: 0 }} onClick={() => setTheme("light", true)}>
              <FontAwesomeIcon icon={faSun} style={{ color: "grey", marginRight: "5px" }} /> Lys modus |
            </Button>
            <Button type="link" style={{ color: "grey", padding: 0 }} onClick={() => setTheme("dark", true)}>
              Mørk modus <FontAwesomeIcon icon={faMoon} style={{ color: "grey", marginLeft: "5px" }} />
            </Button>
          </Col>
          <Col span={width < breakpoint ? 24 : 8} style={width < breakpoint ? {} : { textAlign: "right" }}>
            <Paragraph style={{ color: "grey", paddingRight: "0.37em", paddingTop: "5px" }}>
              {new Date().getFullYear()} <CopyrightOutlined /> Bindeleddet NTNU
            </Paragraph>
          </Col>
        </Row>
      </Row>
    </>
  );
};

export default AdminFooter;
